import React from "react";
import PropTypes from "prop-types";
import ContentWrapper from "../ContentWrapper";
import Block from "../Block";
import Column from "../Column";
import markdown from "../../lib/remark";

const propTypes = {
    className: PropTypes.string
};

const defaultProps = {
    className: ""
};

export default function Text({ leftColumn, rightColumn, className }) {
    return (
        <ContentWrapper className={className}>
            <Block>
                <Column>
                    <div
                        className="cms-content"
                        dangerouslySetInnerHTML={markdown(leftColumn)}
                    />
                </Column>
                <Column>
                    <div
                        className="cms-content"
                        dangerouslySetInnerHTML={markdown(rightColumn)}
                    />
                </Column>
            </Block>
        </ContentWrapper>
    );
}

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;
